import {SplitButton} from './SplitButton';
import {Skeleton} from '../shadcn/skeleton';

import type {SplitButtonProps} from './SplitButton';

/** Loading placeholder for a `SplitButton`, shaped by the same pill rules. */
export function SplitButtonSkeleton(props: Omit<SplitButtonProps, 'children'>) {
  return (
    <SplitButton data-slot="split-button-skeleton" aria-hidden="true" {...props}>
      <Skeleton className="h-10 w-24.5" />
      <Skeleton className="h-10" />
    </SplitButton>
  );
}
